module.exports = __webpack_public_path__ + "static/media/educacaoInfantil.6f4105d1.svg";